const FullVideosScreen = ({ videoUrl }) => {
  return (
    <div style={{ textAlign: "center", margin: "20px" }}>
      <div
        style={{
          position: "relative",
          width: "100%", // Full width
          paddingBottom: "56.25%", // 16:9 aspect ratio
          height: 0,
          margin: "auto",
        }}
      >
        <iframe
          src={videoUrl}
          title="YouTube video player"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: "none",
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default FullVideosScreen;
